import { Routes, Route } from "react-router-dom";
import MenuPage from "../Pages/MenuPage/menuPage";
import AppPage from "../Pages/AppPage/apppage";
import DashboardPage from "../Pages/Dashboard/dashboardPage";
import ProfilePage from "../Pages/ProfilePage/profilePage";
import { lazy, Suspense } from "react";
import { Spin } from "antd";

const AnalyticsPage = lazy(() => import("../Pages/Analytics/analyticsPage"));
const ReportsPage = lazy(() => import("../Pages/Reports/reportsPage"));

// Promotions
const PromotionsList = lazy(() => import("../Pages/Promotions/PromotionsList"));
const CreatePromotion = lazy(() => import("../Pages/Promotions/CreatePromotion"));
const PromotionDetails = lazy(() => import("../Pages/Promotions/PromotionDetails"));

const VendorAppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<AppPage />}>
                <Route path="menu" element={<MenuPage />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route
                    path="analytics"
                    element={
                        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><Spin size="large" /></div>}>
                            <AnalyticsPage />
                        </Suspense>
                    }
                />
                <Route
                    path="reports"
                    element={
                        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><Spin size="large" /></div>}>
                            <ReportsPage />
                        </Suspense>
                    }
                />
                <Route
                    path="promotions"
                    element={
                        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><Spin size="large" /></div>}>
                            <PromotionsList />
                        </Suspense>
                    }
                />
                <Route
                    path="promotions/create"
                    element={
                        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><Spin size="large" /></div>}>
                            <CreatePromotion />
                        </Suspense>
                    }
                />
                <Route
                    path="promotions/:id"
                    element={
                        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><Spin size="large" /></div>}>
                            <PromotionDetails />
                        </Suspense>
                    }
                />
                <Route path="" element={<DashboardPage />} />
            </Route>
        </Routes>
    );
};

export default VendorAppRoutes;